import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '关于我们', href: '/about' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
      <nav className="max-w-7xl mx-auto px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group whitespace-nowrap"
          >
            <span className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-fire-fill text-background-50 text-lg"></i>
            </span>
            <span className="text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
              黑料聚合网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  isActive(link.href)
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
                aria-expanded={categoryOpen}
                aria-haspopup="true"
              >
                分类浏览
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <>
                  <div className="fixed inset-0 z-10" onClick={() => setCategoryOpen(false)} />
                  <div className="absolute top-full right-0 mt-1 w-56 bg-background-50 rounded-lg border border-background-200/70 shadow-lg py-2 z-20">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        onClick={() => setCategoryOpen(false)}
                        className={`flex items-center gap-3 px-4 py-2.5 text-sm transition-colors duration-150 whitespace-nowrap ${
                          location.pathname === `/category/${cat.slug}`
                            ? 'bg-primary-50 text-primary-600'
                            : 'text-foreground-700 hover:bg-background-100'
                        }`}
                      >
                        <span className="w-5 h-5 flex items-center justify-center">
                          <i className={`${cat.icon} text-base`}></i>
                        </span>
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 py-3">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setMobileOpen(false)}
                  className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive(link.href)
                      ? 'bg-primary-50 text-primary-600'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="border-t border-background-200/70 my-1 pt-1">
                <p className="px-4 py-1 text-xs text-foreground-500 font-medium">分类浏览</p>
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    onClick={() => setMobileOpen(false)}
                    className={`flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap ${
                      location.pathname === `/category/${cat.slug}`
                        ? 'bg-primary-50 text-primary-600'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`}
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-base`}></i>
                    </span>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}